<template>
  <v-card>
    <v-card-title class="text-h4 text-center justify-center mb-5">
      {{ $t("labels.changePassword") }}
    </v-card-title>
    <ValidationObserver
      v-if="userId"
      v-slot="{ handleSubmit, invalid }"
      ref="observer"
    >
      <form @submit.prevent="handleSubmit(changePassword)">
        <v-card-text
          class="font-weight-bold body-1"
          style="line-height: 1.8; color: #7443a0"
        >
          <!-- Current Password -->
          <ValidationProvider
            :name="$t('labels.currentPassword')"
            rules="required|min:8"
            v-slot="{ errors }"
          >
            <v-text-field
              :label="$t('labels.currentPassword')"
              v-model="form.currentPassword"
              :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showCurrentPassword ? 'text' : 'password'"
              @click:append="showCurrentPassword = !showCurrentPassword"
              :error-messages="errors"
            />
          </ValidationProvider>

          <!-- New Password -->
          <ValidationProvider
            :name="$t('labels.newPassword')"
            rules="required|min:8"
            v-slot="{ errors }"
          >
            <v-text-field
              :label="$t('labels.newPassword')"
              v-model="form.newPassword"
              :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showNewPassword ? 'text' : 'password'"
              @click:append="showNewPassword = !showNewPassword"
              :error-messages="errors"
              ref="newPassword"
            />
          </ValidationProvider>

          <!-- Re-New Password -->
          <ValidationProvider
            :name="$t('labels.reNewPassword')"
            :rules="{
              required: true,
              min: 8,
              confirmedPassword: $t('labels.newPassword'),
            }"
            v-slot="{ errors }"
          >
            <v-text-field
              :label="$t('labels.reNewPassword')"
              v-model="form.confirmPassword"
              :append-icon="showReNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showReNewPassword ? 'text' : 'password'"
              @click:append="showReNewPassword = !showReNewPassword"
              :error-messages="errors"
            />
          </ValidationProvider>
        </v-card-text>

        <v-card-actions
          style="background-color: white; position: sticky; bottom: 0px"
        >
          <v-spacer></v-spacer>

          <v-btn
            color="deep-purple lighten-2"
            text
            type="submit"
            :disabled="invalid"
          >
            {{ $t("buttons.update") }}
          </v-btn>
          <v-btn
            color="red lighten-2"
            text
            @click="onCancel"
            v-if="onCancel"
          >
            {{ $t("buttons.cancel") }}
          </v-btn>
        </v-card-actions>
      </form>
    </ValidationObserver>
    <h2 v-else>User Id is required!</h2>
  </v-card>
</template>

<script>
import AccountService from "../services/AccountService";

export default {
  name: "UpdatePassword",
  data() {
    return {
      showCurrentPassword: false,
      showNewPassword: false,
      showReNewPassword: false,

      form: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  props: {
    onSuccess: {
      type: Function,
      default: () => {},
    },
    onCancel: {
      type: Function,
      default: null,
    },
    userId: {
      type: Number,
      default: null,
    },
  },
  methods: {
    changePassword() {
      this.$store.state.loadingStatus = true;

      let body = {
        UserId: this.userId,
        OldPassword: this.form.currentPassword,
        NewPassword: this.form.newPassword,
      };

      AccountService.changePassword(body)
        .then(() => {
          window.showSuccess(this.$t(`messages.updatedSuccessfully`));
          if (this.onSuccess) {
            this.onSuccess();
          }
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    clearModal() {
      this.currentPassword = "";
      this.newPassword = "";
      this.reNewPassword = "";
      this.showCurrentPassword = false;
      this.showNewPassword = false;
      this.showReNewPassword = false;
    },
  },
};
</script>
